document.addEventListener('DOMContentLoaded', function () {
  const swiperContainer = document.querySelector('.about-us-slider');

  if (
    swiperContainer &&
    !swiperContainer.classList.contains('swiper-initialized')
  ) {
    const isMobile = window.innerWidth < 992;

    const swiper = new Swiper('.about-us-slider', {
      speed: 300,
      slidesPerView: 1.15,
      spaceBetween: 16,
      grabCursor: true,
      cssMode: isMobile,
      freeMode: true,
      navigation: {
        nextEl: '.about-us-slider .swiper-button-next',
        prevEl: '.about-us-slider .swiper-button-prev'
      },
      breakpoints: {
        500: {
          slidesPerView: 2.05
        },
        800: {
          slidesPerView: 3.05
        },
        992: {
          cssMode: false
        },
        1200: {
          slidesPerView: 4.05
        },
        1500: {
          spaceBetween: 20,
          slidesPerView: 4.05
        }
      }
    });

    swiper.on('slideChange', swiper => {
      if (typeof calculateScrollPercentage === 'function') {
        calculateScrollPercentage(swiper, '.about-us .main_heading');
      }
    });
  }
});
